import { render } from "./MonacoWrapper.vue?vue&type=template&id=064482da&scoped=true&ts=true"
import script from "./MonacoWrapper.vue?vue&type=script&lang=ts"
export * from "./MonacoWrapper.vue?vue&type=script&lang=ts"

import "./MonacoWrapper.vue?vue&type=style&index=0&id=064482da&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064482da"]])

export default __exports__